import { Grid } from '@alfa-bank/site-grid-universal';
import { Text as TextV2 } from '@alfa-bank/site-text-v2';
import { Img } from '@alfa-bank/site-img';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { SpacerVertical } from '@alfa-bank/site-deprecated-spacer-vertical';
import { TextDesktop as Text } from '@alfa-bank/site-deprecated-text/desktop';
import { Breadcrumbs } from '@alfa-bank/site-breadcrumbs';
import { ResponsiveBackground } from '@alfa-bank/site-responsive-background';
import { Background } from '@alfa-bank/site-background';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BenefitsDesktop as Benefits } from '@alfa-bank/site-benefits/default/desktop';
import { IconShortArrow } from '@alfa-bank/site-icon/short-arrow';
import { Case } from '@alfa-bank/site-content-switcher/case';
import { Switch } from '@alfa-bank/site-content-switcher/switch';
import { Link } from '@alfa-bank/site-link';
import { Timer } from '@alfa-bank/site-timer';
import { Button } from '@alfa-bank/site-button-v2';

import styles from '../styles/default/desktop.css';
import { Component } from '../layouts/default/desktop';
import { bannerBenefits } from '../utils/banner-benefits/default';
import { bannerBreadcrumbs } from '../utils/banner-breadcrumbs';
import { bannerImage } from '../utils/banner-image/default';
import { bannerSubtitle } from '../utils/banner-subtitle/default';
import { imageSources } from '../utils/image-sources/desktop';
import { renderTitle } from '../utils/render-title/default';
import type { TDesktop, IDesktopComponents } from '../models/desktop';
import { bannerSubMenu } from '../utils/banner-sub-menu';
import { BannerButton } from '../utils/banner-button';
import { BannerBackground } from '../utils/banner-background';

/* eslint-disable-next-line create-widget/deps-components-typeof */
export const MainBannerDesktop = createWidget<IDesktopComponents<TDesktop>, TDesktop>({
    bannerBenefits,
    bannerBreadcrumbs,
    bannerSubMenu,
    BannerButton,
    IconShortArrow,
    bannerImage,
    bannerSubtitle,
    imageSources,
    renderTitle,
    Switch,
    BannerBackground,
    Case,
    Link,
    Timer,
    Button,
    Benefits,
    Breadcrumbs,
    Grid,
    TextV2,
    Img,
    Background,
    Layout,
    ResponsiveBackground,
    SpacerVertical,
    styles,
    Text,
})(Component);
